import React from 'react';

import { ServiceCard } from '../../helpers/list-page/interfaces/list-card.interface';
import ImageWrapper from '../image-wrapper/Image-wrapper';
import { FavouriteButton } from '../ui/favourite-button/favourite-button';
import Link from 'next/link';

interface CardServiceProps {
  card: ServiceCard;
  cardIndex: number;
}

export const CardService = ({ card, cardIndex }: CardServiceProps) => {
  return (
    <div className="relative">
      <Link
        href={card?.slug}
        key={card?.id}
        className={`group flex aspect-8/9 cursor-pointer flex-col items-center justify-center rounded-xl bg-background-primary-light transition-opacity duration-200 ease-in-out lg:hover:bg-background-secondary focus:outline focus:outline-3 focus:outline-offset-3 focus:outline-text-light `}
      >
        {card?.imageWrapper?.jsonBynderAsset?.originalUrl && (
          <ImageWrapper
            url={card?.imageWrapper?.jsonBynderAsset?.originalUrl}
            alt={card?.imageWrapper?.altText || 'alt text not found'}
            className=""
            imgClassName="object-cover mb-3.5 w-20 lg:mb-10 h-auto"
            width={80}
            height={card?.image?.height ? parseInt(card.image.height) : 80}
          />
        )}
        <div className="mt-1 w-full break-words px-6 text-center font-title text-headingxs text-text-light">
          {card?.name}
        </div>
      </Link>
      <FavouriteButton
        id={card.id}
        type="service"
        className="absolute top-2 right-2 z-1"
        name={card?.name}
      />
    </div>
  );
};
